var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "#A6B6C5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9526 11.9469C10.6856 13.2153 8.93445 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 8.57096 13.4825 10.0211 12.6087 11.1891L15.101 13.6631C15.297 13.8577 15.2976 14.1737 15.1023 14.3689C14.907 14.5642 14.5899 14.5648 14.3939 14.3702L11.9526 11.9469ZM11.4323 11.0437C10.3351 12.2458 8.75544 13 6.99963 13C3.68592 13 0.999624 10.3137 0.999624 7.00002C0.999624 3.68631 3.68592 1.00002 6.99963 1.00002C10.3133 1.00002 12.9996 3.68631 12.9996 7.00002C12.9996 8.42096 12.5057 9.72653 11.6801 10.7544C11.6346 10.7777 11.5918 10.8084 11.5537 10.8464C11.4964 10.9038 11.4559 10.9716 11.4323 11.0437Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e510cbe91fd77e462c2198950def3851.svg";
export { ForwardRef as ReactComponent };